import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme) => ({
  container: {
    maxWidth: 1920,
    margin: "auto",
    padding: "48px 16px",
  },

  prizeList: {
    display: "flex",
    flexDirection: "row",
    gap: 8,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,

    maxWidth: 1440,
    padding: "16px 0",
    margin: "auto",
    overflowX: "scroll",
    justifyContent: "space-around",
  },

  prize: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    color: theme.design.color.text.primary,
    textAlign: "center",
    fontSize: 20,
    fontWeight: 900,
    minWidth: 100,

    "& img": {
      width: 32,
      height: 32,
      borderRadius: 4,
    },

    [theme.breakpoints.down("sm")]: {
      minWidth: 140,
    },
  },

  prizeInfo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    height: 32,

    "& img": {
      objectFit: "contain",
    },

    "& p": {
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
      fontSize: 12,
    },
  },

  prizeCard: {
    backgroundColor: theme.design.color.surface.container,
    borderRadius: 16,
    display: "grid",
    alignItems: "center",
    flexDirection: "column",
    padding: "24px 8px",
    minWidth: "120px",
    color: theme.design.color.text.primary,
    textAlign: "center",
    fontSize: 13,
    gap: 16,
    height: "100%",

    [theme.breakpoints.down("sm")]: {
      padding: "24px 8px",
    },
  },

  stock: {
    fontSize: 12,
    color: theme.design.color.text.secondary,
    height: "14px",
  },

  nameWithStock: {
    display: "flex",
    flexDirection: "column",
    gap: 8,

    "& p": {},
  },

  itemValue: {
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    fontSize: 14,
    color: theme.design.color.text.primary,
  },

  itemStock: {
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    fontSize: 12,
    color: theme.design.color.text.secondary,
    height: "14px",
  },
}));

export default styles;
